<template>
	<div class="titles-count">{{ titleCountLabel }}</div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

import { storeToRefs } from 'pinia';
import { useLanguageStore } from '@/stores/pinia/useLanguageStore';

const props = withDefaults(
	defineProps<{
		count?: number;
	}>(),
	{
		count: 0,
	}
);

const { language } = storeToRefs(useLanguageStore());
const { t } = useI18n();

const titleCountLabel = computed(() => {
	const integerFormat = new Intl.NumberFormat(language.value);
	const localizedCount = integerFormat.format(props.count);

	return props.count === 1
		? t('WEBAPP_TITLE', { NUMBER: localizedCount })
		: t('WEBAPP_TITLES', { NUMBER: localizedCount });
});
</script>

<style lang="scss" scoped>
@import '~@/styles/variables';

.titles-count {
	color: $jw-color-lightgray--dark;
	font-size: 12px;
	white-space: nowrap;
}
</style>
